import { render } from "./MatrixCellSelectionLabel.vue?vue&type=template&id=6c8c0206"
import script from "./MatrixCellSelectionLabel.vue?vue&type=script&lang=js"
export * from "./MatrixCellSelectionLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__